import React from 'react'
import Icon from '../components/Icon'

class Notifications extends React.Component {
    constructor (props) {
        super(props)

        this.icon = (this.props.icon ? this.props.icon : 'icon-magnify.svg')
    }

    render () {
        return (
            <div className='notifications module text-center text-md-left'>
                <div className='module-inner'>
                    <Icon src={`/images/${this.icon}`} />
                    <div className='items'>
                        {this.props.children}
                    </div>
                </div>
            </div>
        )
    }
}

export default Notifications



// WEBPACK FOOTER //
// ./resources/js/modules/Notifications.js